import { Component, Inject, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppState } from '../../../../../core/reducers';
import { currentUser } from '../../../../../core/auth';
import { AddEditDeviceInventoryComponent } from '../device-inventory/add-edit-device-inventory/add-edit-device-inventory.component';

@Component({
  selector: 'kt-patient-ranges',
  templateUrl: './patient-ranges.component.html',
  styleUrls: ['./patient-ranges.component.scss'],
})
export class PatientRangesComponent {
  disableBtns: any;
  isCreate: any;
  model;
  companyId: any;

  inventoryForm: any;
  rangeModel: any;
  @ViewChild('formio') formio;
  disableSaveBtns: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddEditDeviceInventoryComponent>,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
    this.model = {
      data: typeof this.data.model === 'string' ? JSON.parse(this.data.model) : this.data.model,
    };
    // tslint:disable-next-line:max-line-length
    this.inventoryForm = this.data.inventoryForm;
  }

  onCancelClick() {
    this.close(false);
  }

  onSubmit() {
    this.close(this.rangeModel);
  }

  private close(model) {
    this.dialogRef.close({
      data: model,
    });
  }

  onChange(event) {
    if (event.data) this.rangeModel = event.data;
    this.disableSaveBtns = !this.formio.formio.checkValidity();
  }
}
